export default __webpack_public_path__ + "static/media/fileArchiveDisable.0d56d5db.svg";